/* ==============================================================================================
 * [ACCESS] EXPORT LIST OPTION TABLE
 *
 * Export List's tables (LEI, Loan and Option) files have almost identical content because
 * currrently there is no information about which fields exist in each. To keep it flexible for
 * future structure changes, those are already splitted into separate files.
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/access/exportListOption.json";
	var tableElement = document.querySelector("#accessExportListOptionTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "identifier",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "displayName",
				className: "c-table__cell",
			},
			{
				data: "description",
				className: "c-table__cell",
			},
			{
				data: null,
				orderable: false,
				className: "c-table__cell c-table__cell--remove",
				defaultContent: "",
			},
		],
		columnDefs: [
			{
				targets: [3],
				width: "1%",
				render: CGS.renderRemoveCell,
			},
		],
		initComplete: CGS.createRetractTableWrapper,
		dom: "<'top'>rt<'c-tableFooter'pi<'c-tableExport c-tableExport--batch'B>>",
		buttons: [
			CGS.getClearExportListButton(),
			CGS.getExportToExcelButton(),
		],
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
